module.exports = __webpack_public_path__ + "img/Logo-01.371b013c.png";